/*============================================================================
Setting Up Ingredients Tabs
==============================================================================*/


function openIngredient(evt, ingredientName) {
  // Declare all variables
  var i, tabcontent, tablinks;

  // Get all elements with class="tabcontent" and hide them
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Get all elements with class="tablinks" and remove the class "active"
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(ingredientName).style.display = "block";
  evt.currentTarget.className += " active";
}

function setInitialIngredient(){
  try{
    tablinks = document.getElementsByClassName("tablinks");
    tablinks[0].click()
  } catch(e){
  	console.log("no tablinks on this page")
  }
  
}

setInitialIngredient()

function nextOpenIngredients(){
  	tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      if (tablinks[i].className == "tablinks active"){
        if(i == tablinks.length - 1){
          tablinks[0].click()
          return
        }
        tablinks[i+1].click()
        return
      }
    }
}

function prevOpenIngredients(){
  	tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      if (tablinks[i].className == "tablinks active"){
      	console.log("active tab found!")
        console.log(tablinks[i])
        if(i == 0){
          tablinks[tablinks.length-1].click()
          return
        }
        tablinks[i-1].click()
        return
      }
    }
}